import type { MouseEventHandler } from "react";
import { Typography } from "../atoms/Typography";
import type { LucideIcon } from "lucide-react";


type CategoryCardProps = {
  readonly title: string;
  readonly description: string;
  readonly icon: LucideIcon;
  readonly onClick?: MouseEventHandler<HTMLButtonElement>;
};

export const CategoryCard = ({
  title,
  description,
  icon: Icon,
  onClick
}: CategoryCardProps) => (
  <button
    type="button"
    onClick={onClick}
    className="group flex h-full flex-col rounded-xl border border-gray-200 bg-white p-6 text-left shadow-sm transition-all duration-200 ease-in-out hover:-translate-y-0.5 hover:shadow-card focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2"
  >
    <div className="mb-3 inline-flex h-10 w-10 items-center justify-center rounded-lg bg-primary-50 text-primary-700">
      <Icon className="h-5 w-5 shrink-0" strokeWidth={1.75} aria-hidden />
    </div>
    <Typography as="h3" variant="h3" className="mb-1">
      {title}
    </Typography>
    <Typography variant="muted">{description}</Typography>
  </button>
);

